import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { select, Store } from '@ngrx/store';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { filter, take } from 'rxjs/operators';
import { getFilteredUnloadTypes } from '../../../selectors/single-catalogs';
import { ChangeUnloadTimeAction, LoadUnloadTimeFilteredCatalogAction } from '../../../actions/single-catalogs.actions';

/**
 * Sets default value for unloadTime and spacing
 * Used only for FR at the moment
 */
@Injectable()
export class HandleUnloadTypeDefaults implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup): void {
    this.store
      .pipe(
        select(getFilteredUnloadTypes),
        filter((unloadTypes) => !!value && unloadTypes.length > 0),
        take(1),
      )
      .subscribe((unloadTypes) => {
        const selectedUnloadType = unloadTypes.find((unloadType) => unloadType.unloadTypeCode === value);
        !!_safe(() => selectedUnloadType.unloadTimeCode) &&
          this.store.dispatch(new LoadUnloadTimeFilteredCatalogAction(selectedUnloadType.unloadTimeCode));
        !!_safe(() => selectedUnloadType.spacing) &&
          this.store.dispatch(new ChangeUnloadTimeAction(Number(selectedUnloadType.spacing)));

        if (!formGroup.get(SpecFieldNames.UNLOAD_TYPE).pristine) {
          formGroup.get(SpecFieldNames.DISCHARGE_TIME).setValue(selectedUnloadType.unloadTimeCode);
          formGroup.get(SpecFieldNames.SPACING).setValue(selectedUnloadType.spacing);
        }
      });
  }
}
